import { tw } from '@/utils/tw';
import BaseMorePagesTitleTheme from 'base/components/MorePagesTitle/theme';

const MorePagesTitle = tw.theme({
  extend: BaseMorePagesTitleTheme,
  base: `before:bg-linen-300 order-1 m-6 flex flex-row items-center gap-3 whitespace-nowrap text-headline-xl before:order-2 before:block before:h-0.25 before:w-full after:order-3 after:block after:h-6 after:w-100 after:bg-[url("/image/femina-logo-red.svg")] after:bg-no-repeat sm:after:w-40 md:after:w-32`,
});

export default MorePagesTitle;
